import wretch from "wretch";
import config from "@/config";
import { LMSTokensType } from "@/types/auth";
import { jwtDecode } from "jwt-decode";

export const LMSAuthService = {
    authenticated: false,
    client: wretch(config.LMS_BACKEND_URL[import.meta.env.VITE_RELEASE_STAGE as keyof typeof config.LMS_BACKEND_URL], {
        credentials: "include",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    }),
    refresh: async (refresh_token: string) => {
        return LMSAuthService.client
            .url("/auth/refresh/")
            .post({ refresh: refresh_token })
            .json(data => {
                const decoded_token = jwtDecode(data.access);
                LMSAuthService.authenticated = true;

                // Vérifie si on est en mode view_as
                const isViewAs = localStorage.getItem("view_as_tokens") !== null;
                const tokens = {
                    access: data.access,
                    access_expires: decoded_token.exp || Date.now() / 1000
                };

                if (isViewAs) {
                    LMSAuthService.set_view_as_tokens(tokens);
                } else {
                    LMSAuthService.set_tokens(tokens);
                }
            });
    },
    set_tokens: (tokens: LMSTokensType) => {
        localStorage.setItem("lms_tokens", JSON.stringify(tokens));
    },
    set_view_as_tokens: (tokens: LMSTokensType) => {
        localStorage.setItem("lms_view_as_tokens", JSON.stringify(tokens));
    },
    get_view_as_tokens: () => {
        const tokensRaw = localStorage.getItem("lms_view_as_tokens");
        if (tokensRaw) {
            return JSON.parse(tokensRaw) as LMSTokensType;
        }
        return null;
    },
    remove_view_as_tokens: () => {
        localStorage.removeItem("lms_view_as_tokens");
    },
    get_tokens: () => {
        const isViewAs = localStorage.getItem("view_as_tokens") !== null;
        const viewAsTokensRaw = localStorage.getItem("lms_view_as_tokens");
        if (viewAsTokensRaw && isViewAs) {
            return JSON.parse(viewAsTokensRaw) as LMSTokensType;
        }
        const tokensRaw = localStorage.getItem("lms_tokens");
        if (tokensRaw && !isViewAs) {
            return JSON.parse(tokensRaw) as LMSTokensType;
        }
        return null;
    },
    get_csrf: () => {
        const cookies = document.cookie.split(";").map(cookie => cookie.trim());
        const csrf = cookies.find(cookie => cookie.startsWith("csrftoken="));
        if (csrf) {
            return csrf.split("=")[1];
        }
        return null;
    },
    has_access_expires: () => {
        const tokens = LMSAuthService.get_tokens();
        if (tokens) {
            return tokens.access_expires - 24 * 3600 <= Date.now() / 1000;
        }
        return true;
    }
};
